import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Check } from "lucide-react";
import { useLang, CONTACT } from "../i18n";
import { RevealText } from "./Reveal";

const BG = "https://customer-assets-rejwkqb3.emergentagent.net/job_reformas-acero/artifacts/0hyekplo_local%20despues.webp";
const waHref = (label) => `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(label)}`;

export default function Presupuestos() {
  const { t } = useLang();
  const p = t.presupuestos;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative py-28 md:py-40 overflow-hidden grain">
      <motion.img style={{ y }} src={BG} alt="" className="absolute inset-0 h-full w-full object-cover scale-110 opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-bg via-black/70 to-bg" />

      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-px w-10 bg-brand-orange" />
          <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-brand-orange">{p.overline}</span>
        </div>
        <RevealText
          as="h2"
          text={p.title}
          className="font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl lg:text-7xl block max-w-4xl"
        />
        <p className="mt-8 max-w-2xl text-steel-300 text-base md:text-lg leading-relaxed">{p.p}</p>

        <div className="mt-10 flex flex-col gap-4">
          {p.points.map((pt, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="flex items-center gap-4"
            >
              <span className="h-8 w-8 rounded-full bg-brand-orange text-black grid place-items-center shrink-0">
                <Check className="h-4 w-4" strokeWidth={3} />
              </span>
              <span className="text-lg md:text-xl font-medium">{pt}</span>
            </motion.div>
          ))}
        </div>

        <a
          href={waHref(p.cta)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="presupuesto-cta"
          className="mt-12 inline-flex items-center gap-2 bg-brand-orange text-black font-semibold px-8 py-4 rounded-full hover:bg-white transition-colors duration-300"
        >
          {p.cta}
        </a>
      </div>
    </section>
  );
}
